var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgBackgroundIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 38.374H11c-1.7 0-3-1.3-3-3v-20c0-1.7 1.3-3 3-3h28c1.7 0 3 1.3 3 3v20c0 1.7-1.3 3-3 3Zm-28-24c-.6 0-1 .4-1 1v20c0 .6.4 1 1 1h28c.6 0 1-.4 1-1v-20c0-.6-.4-1-1-1H11Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.374c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4Zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2ZM35.3 38.074 19 22.774l-9.3 8.6-1.4-1.4 10.7-10 17.7 16.7-1.4 1.4Z",
    fill: "#7B7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.4 33.074-5.4-4.4-4.5 3.7-1.3-1.6 5.8-4.7 6.6 5.4-1.2 1.6Z",
    fill: "#7B7B7B"
  })));
};
export { SvgBackgroundIcon as ReactComponent };
export default __webpack_public_path__ + "d273d960ac0ef1c67cb1af3e2eccbba6.svg";